import PortalIdParser from 'PortalIdParser';
import * as React from 'react';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getUrlForObjectTypeId } from 'flow-doctor-lib/utils/objectUtils';
import useObjectTypeIdFromAssociation from 'flow-doctor-lib/hooks/useObjectTypeIdFromAssociation';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const getMessageForAssociationAudit = audit => {
  if (audit.active) {
    return audit.auditUser.userId ? 'flow-doctor-lib.flows.objectLifecycle.associationHistory.label.added.withUser_jsx' : 'flow-doctor-lib.flows.objectLifecycle.associationHistory.label.added.withoutUser_jsx';
  }
  return audit.auditUser.userId ? 'flow-doctor-lib.flows.objectLifecycle.associationHistory.label.removed.withUser_jsx' : 'flow-doctor-lib.flows.objectLifecycle.associationHistory.label.removed.withoutUser_jsx';
};
const AssociationChangeTimelineItemLabel = ({
  logItem
}) => {
  const {
    objectTypeId,
    error
  } = useObjectTypeIdFromAssociation({
    portalId: PortalIdParser.get(),
    associationTypeId: logItem.data.association.associationTypeId,
    associationCategory: logItem.data.association.associationCategory
  });
  if (error) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: logItem.data.associationAudit.active ? 'flow-doctor-lib.flows.objectLifecycle.associationHistory.label.added.errorLabel_jsx' : 'flow-doctor-lib.flows.objectLifecycle.associationHistory.label.removed.errorLabel_jsx',
      elements: {
        b: 'b'
      },
      options: {
        objectId: logItem.data.association.toObjectId
      }
    });
  }
  if (!objectTypeId) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: getMessageForAssociationAudit(logItem.data.associationAudit),
      elements: {
        b: 'b',
        ObjectTypeLabel,
        ObjectNameLabel,
        ViewLink: UILink,
        UserNameLabel
      },
      options: {
        objectTypeLabel: {
          lowerCase: true,
          objectTypeId,
          portalId: PortalIdParser.get()
        },
        objectName: {
          portalId: PortalIdParser.get(),
          objectTypeId: objectTypeId,
          objectId: logItem.data.association.toObjectId,
          showId: getIsInternal()
        },
        viewLink: {
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.actions.viewRecord"
          }),
          href: getUrlForObjectTypeId({
            portalId: PortalIdParser.get(),
            objectTypeId: objectTypeId,
            objectId: logItem.data.association.toObjectId
          })
        },
        userId: logItem.data.associationAudit.auditUser.userId
      }
    })
  });
};
export default AssociationChangeTimelineItemLabel;